// extracted by mini-css-extract-plugin
export var socialIcons = "SocialIcons--socialIcons--JJZKB";
export var socialIcons__icon = "SocialIcons--socialIcons__icon--r--It";
export var tkMyriadProSemiCondensed = "SocialIcons--tk-myriad-pro-semi-condensed--4w7Sc";